import type { ClarifyingQuestion } from '@revelio/core';

import type {
  ReportIntent,
  ReportLLMTabContent,
} from './report-layout-helpers';

export type ReportSSEEvent =
  | { type: 'thinking'; content: string }
  | { type: 'status'; content: string }
  | { type: 'intent'; content: ReportIntent }
  | { type: 'config'; content: ReportLLMTabContent }
  | { type: 'error'; content: string }
  | {
      type: 'questions';
      content: { questions: ClarifyingQuestion[]; triggerReason: string };
    };

export async function readSSEStream(
  reader: ReadableStreamDefaultReader<Uint8Array>,
  onEvent: (event: ReportSSEEvent) => void
): Promise<void> {
  const decoder = new TextDecoder();
  let buffer = '';

  const processLine = (line: string) => {
    if (!line.startsWith('data: ')) return;
    const jsonStr = line.slice(6);
    if (!jsonStr.trim()) return;
    try {
      onEvent(JSON.parse(jsonStr) as ReportSSEEvent);
    } catch {
      // Ignore parse errors for incomplete chunks (expected during streaming)
    }
  };

  try {
    let reading = true;
    while (reading) {
      const { done, value } = await reader.read();
      if (done) {
        reading = false;
      } else {
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() ?? '';
        lines.forEach(processLine);
      }
    }
    if (buffer.trim()) processLine(buffer);
  } finally {
    reader.cancel().catch(() => undefined);
  }
}
